import React, {useEffect, useState} from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import classNames from "classnames";
import { isNullOrWhitespace } from "../../../utils/objects-util";

const NumberInput = ({
    t,
    value,
    placeholder,
    className,
    isReadonly,
    isInteger,
    minlength, maxLength,
    min, minError,
    max, maxError,
    onChange,
    useParentValueOnly,
    valueAsString,
}) => {

    const [localVale, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleOnChange = e => {
        const targetValue = e.target.value.toString() ?? '';
        const isChecked = isInteger || (!value && !targetValue.includes(".") && !targetValue.includes(","));
        const newValue = isChecked ? parseInt(targetValue) : parseFloat(targetValue ?? 0);

        onChange && onChange(valueAsString ? targetValue : newValue);
        if(isChecked && newValue) {
            setLocalValue(newValue);
        } else {
            setLocalValue(e.target.value);
        }
    }

    const handleOnBlur = e => {
        if(Number.isInteger(min)) {
            if(isNullOrWhitespace(value.toString())) {
                toast.error(minError || `${t("basic.error.NUMBER_MIN_VALUE")}: ${min}`);
                onChange && onChange(min);
            } else if(value < min) {
                toast.error(minError || `${t("basic.error.NUMBER_MIN_VALUE")}: ${min}`);
                onChange && onChange(min);
            }
        }

        if(Number.isInteger(max) && isNullOrWhitespace(max.toString())) {
            if(isNullOrWhitespace(value.toString())) {
                toast.error(maxError || `${t("basic.error.NUMBER_MAX_VALUE")}: ${max}`);
                onChange && onChange(max);
            } else if(value > max) {
                toast.error(minError || `${t("basic.error.NUMBER_MAX_VALUE")}: ${max}`);
            }
        }
    }

    return (
        <input
          type="number"
          step="any"
          className={classNames(className || "")}
          value={useParentValueOnly ? value : localVale}
          readOnly={isReadonly}
          minLength={minlength}
          maxLength={maxLength}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          onWheel={(e) => e.target.blur()}
          placeholder={placeholder}
        />
    )
}

export default withTranslation()(NumberInput);